/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


export class DeactivateAccountRequest {
  /**
  * Domain of the EON account to validate
  */
  'domain': string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "domain",
      "baseName": "domain",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return DeactivateAccountRequest.attributeTypeMap;
  }

  public constructor() {
  }
}

